/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Why_2_TInputs */

const en_cp_why_2_t = /** @type {(inputs: Cp_Why_2_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Process assessment, not only the product`)
};

const id_cp_why_2_t = /** @type {(inputs: Cp_Why_2_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penilaian proses, bukan cuma produk`)
};

/**
* | output |
* | --- |
* | "Process assessment, not only the product" |
*
* @param {Cp_Why_2_TInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_why_2_t = /** @type {((inputs?: Cp_Why_2_TInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Why_2_TInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_why_2_t(inputs)
	return en_cp_why_2_t(inputs)
});